import { getTranslator } from '@i18n';
import router from '@router';
import { handleError } from '@util/errors';
import parseCode from '@util/parseCode';

let _onScannerResult: ((text: string) => void) | undefined;

export async function simulateScan(text: string) {
  if (_onScannerResult) {
    _onScannerResult(text);
    return;
  }

  const result = parseCode(text);
  const t = await getTranslator(navigator.language ?? 'en');

  if (result.type === 'device') {
    router.navigate({
      to: '/inventory/$deviceType/$deviceId',
      params: { deviceType: result.deviceType, deviceId: result.uid },
      state: { fromScanner: true },
    });
  } else {
    handleError(t('scanner.unknownCode'));
  }
}

Object.assign(window, { simulateScan });

export function onScannerResult(callback: (text: string) => void) {
  _onScannerResult = callback;

  return () => {
    if (_onScannerResult === callback) {
      _onScannerResult = undefined;
    }
  };
}
